import React, { useState, useEffect } from "react";
import { isActive, isStudent, useAuth } from "../../contexts/AuthContext";
import { Box, Button, TextField, Stack, Paper, Divider, Grid2, Card, CardContent, CardHeader, Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import LockIcon from "@mui/icons-material/Lock";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PhoneIcon from "@mui/icons-material/Phone";
import { useNavigate } from "react-router-dom";
import AsyncButton from "../../components/common/AsyncButton";
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";

const Profile = () => {
    const { user, updateUser } = useAuth()
    const navigate = useNavigate()
    const [isActivationInProgress, setIsActivationInProgress] = useState(false)

    const getActivationStatus = async () => {
        const response = await InvokeAPI(
            `${getUserMgmtBase()}/v1/user/enroll/activation-status`,
            {
                "UserID": user["id"],
            },
            'POST',
            { "authorization": user["token"] },
            false
        )
        if (response["unauthenticated"] == true || response["unauthorized"] == true || response["othererror"] == true) {
            return
        }
        if (response.response && response.response["IsInProgress"] === true) {
            setIsActivationInProgress(true)
        }
    }

    useEffect(() => {
        if (!user["isActive"] && user && user["id"]) {
            getActivationStatus()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    const RenderCurrent = () => {

        return (
            <Card
                elevation={6}
                sx={{
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                        transform: 'translateY(-2px)',
                    },
                }}
            >
                <CardHeader 
                    sx={{ textAlign: 'center', pb: 1 }}
                    title={
                        <Typography 
                            sx={{ 
                                fontWeight: 600,
                                fontSize: '1.125rem',
                                color: 'text.primary',
                                letterSpacing: '-0.01em',
                                textAlign: 'center',
                                width: '100%'
                            }} 
                            variant="h6"
                        >
                            Current Details
                        </Typography>
                    } 
                />
                <CardContent>
                    <Box sx={{ borderRadius: '0 0 12px 12px', overflow: 'hidden' }}>
                        <TableContainer>
                            <Table sx={{ width: "auto" }}>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell align="right" sx={{ fontWeight: 600 }}>UserName : </StyledTableCell>
                                        <StyledTableCell>{user["username"]}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell align="right" sx={{ fontWeight: 600 }}>First Name : </StyledTableCell>
                                        {user["fname"] === "" && <StyledTableCell >-Not Provided-</StyledTableCell>}
                                        {user["fname"] !== "" && <StyledTableCell >{user["fname"]}</StyledTableCell>}
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell align="right" sx={{ fontWeight: 600 }}>Last Name : </StyledTableCell>
                                        {user["lname"] === "" && <StyledTableCell >-Not Provided-</StyledTableCell>}
                                        {user["lname"] !== "" && <StyledTableCell >{user["lname"]}</StyledTableCell>}
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell align="right" sx={{ fontWeight: 600 }}>Phone : </StyledTableCell>
                                        {user["phone"] === "" && <StyledTableCell >-Not Provided-</StyledTableCell>}
                                        {user["phone"] !== "" && <StyledTableCell >{user["phone"]}</StyledTableCell>}
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </CardContent>
            </Card>
        )
    }

    const RenderUpdate = () => {
        const [profileData, setProfileData] = useState({
            id: user["id"],
            username: user["username"],
            fname: user["fname"],
            lname: user["lname"],
            phone: user["phone"],
            referredCode: "",
        }
        );
        const handleEditChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            setProfileData({ ...profileData, [name]: value });
        };

        const handleUpdateUser = async (e) => {
            e.preventDefault();
            if (profileData["username"] === "") {
                profileData["username"] = user["username"]
            }
            if (profileData["fname"] === "") {
                profileData["fname"] = user["fname"]
            }
            if (profileData["lname"] === "") {
                profileData["lname"] = user["lname"]
            }
            if (profileData["phone"] === "") {
                profileData["phone"] = user["phone"]
            }
            updateUser(profileData)
        }
        return (
            <Card
                elevation={6}
                sx={{
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                        transform: 'translateY(-2px)',
                    },
                }}
            >
                <CardHeader 
                    sx={{ textAlign: 'center', pb: 1 }}
                    title={
                        <Typography 
                            sx={{ 
                                fontWeight: 600,
                                fontSize: '1.125rem',
                                color: 'text.primary',
                                letterSpacing: '-0.01em',
                                textAlign: 'center',
                                width: '100%'
                            }} 
                            variant="h6"
                        >
                            Edit Profile
                        </Typography>
                    } 
                />
                <CardContent>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Stack>
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <AccountCircleIcon color="primary" />
                                <TextField
                                    label="Username"
                                    variant="outlined"
                                    name="username"
                                    value={profileData["username"]}
                                    onChange={handleEditChange}
                                    sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                    autoComplete="true"
                                />
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <PersonIcon sx={{ color: "black" }} />
                                <TextField
                                    label="First Name"
                                    variant="outlined"
                                    name="fname"
                                    value={profileData["fname"]}
                                    onChange={handleEditChange}
                                    sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                    autoComplete="true"
                                />
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <BadgeIcon sx={{ color: "purple" }} />
                                <TextField
                                    label="Last Name"
                                    variant="outlined"
                                    name="lname"
                                    value={profileData["lname"]}
                                    onChange={handleEditChange}
                                    sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                    autoComplete="true"
                                />
                            </Box>
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <PhoneIcon color="primary" />
                                <TextField
                                    label="Phone"
                                    variant="outlined"
                                    name="phone"
                                    value={profileData["phone"]}
                                    onChange={handleEditChange}
                                    sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                    autoComplete="true"
                                />
                            </Box>
                        </Stack>
                    </Box>

                    <Box display="flex" justifyContent="center" alignItems="center">
                        <AsyncButton 
                            type="submit" 
                            variant="contained" 
                            color="primary" 
                            onClick={handleUpdateUser}
                            sx={{
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: (theme) => theme.shadows[8],
                                },
                            }}
                        >
                            Update
                        </AsyncButton>
                    </Box>
                </CardContent>
            </Card>
        );
    };

    const SelfActivation = () => {
        return (
            <Card
                elevation={6}
                sx={{
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                        transform: 'translateY(-2px)',
                    },
                }}
            >
                <CardHeader 
                    sx={{ textAlign: 'center', pb: 1 }}
                    title={
                        <Typography 
                            sx={{ 
                                fontWeight: 600,
                                fontSize: '1.125rem',
                                color: 'text.primary',
                                letterSpacing: '-0.01em',
                                textAlign: 'center',
                                width: '100%'
                            }} 
                            variant="h6"
                        >
                            Account Status
                        </Typography>
                    } 
                />
                <CardContent>
                    {isActive() ?
                        <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 2 }}>
                            <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
                                Your account is activated, you can take self-test assessments.
                            </Typography>
                        </Box>
                    :
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Stack spacing={2} sx={{ width: '100%' }}>
                                {isActivationInProgress ? (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
                                            Your account is being activated.
                                        </Typography>
                                    </Box>
                                ) : (
                                    <>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
                                                If you want to take self-test assessments click below to activate.
                                            </Typography>
                                        </Box>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <Button 
                                                type="submit" 
                                                color="success" 
                                                variant="contained" 
                                                onClick={(e) => { e.preventDefault(); navigate("/app/activate/" + user["id"]) }}
                                                sx={{
                                                    background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                    transition: 'all 0.2s ease-in-out',
                                                    boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                                    '&:hover': {
                                                        background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                        transform: 'translateY(-2px)',
                                                        boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                                    },
                                                }}
                                            >
                                                Activate
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </Stack>
                        </Box>
                    }
                </CardContent>
            </Card>
        );
    }
    const RenderReferralUpdate = () => {
        const [profileData, setProfileData] = useState({
            id: user["id"],
            username: "",
            fname: "",
            lname: "",
            phone: "",
            referredCode: "",
        }
        );
        const handleEditChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            setProfileData({ ...profileData, [name]: value });
        };

        const handleUpdateUser = async (e) => {
            e.preventDefault();
            if (profileData["username"] === "") {
                profileData["username"] = user["username"]
            }
            if (profileData["fname"] === "") {
                profileData["fname"] = user["fname"]
            }
            if (profileData["lname"] === "") {
                profileData["lname"] = user["lname"]
            }
            if (profileData["phone"] === "") {
                profileData["phone"] = user["phone"]
            }
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/update`,
                {
                    "ID": profileData["id"],
                    "Username": profileData["username"],
                    "Fname": profileData["fname"],
                    "Lname": profileData["lname"],
                    "Phone": profileData["phone"],
                    "ReferredCode": profileData["referredCode"]
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                // Handle logout if needed
            }
        }
        return (
            <Card
                elevation={6}
                sx={{
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                        transform: 'translateY(-2px)',
                    },
                }}
            >
                <CardHeader 
                    sx={{ textAlign: 'center', pb: 1 }}
                    title={
                        <Typography 
                            sx={{ 
                                fontWeight: 600,
                                fontSize: '1.125rem',
                                color: 'text.primary',
                                letterSpacing: '-0.01em',
                                textAlign: 'center',
                                width: '100%'
                            }} 
                            variant="h6"
                        >
                            Referral Detail
                        </Typography>
                    } 
                />
                <CardContent>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Stack spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                                    Code of user who referred you
                                </Typography>
                            </Box>

                            <TextField
                                label="Referral's User Code"
                                variant="outlined"
                                name="referredCode"
                                value={profileData["referredCode"]}
                                onChange={handleEditChange}
                                fullWidth
                                autoComplete="true"
                            />
                        </Stack>
                    </Box>

                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 3 }}>
                        <AsyncButton 
                            type="submit" 
                            variant="contained" 
                            color="primary" 
                            onClick={handleUpdateUser}
                            sx={{
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: (theme) => theme.shadows[8],
                                },
                            }}
                        >
                            Update
                        </AsyncButton>
                    </Box>
                </CardContent>
            </Card>
        );
    };

    /*
                                <StyledTableRow>
                                <StyledTableCell align="right">Your Referral Code : </StyledTableCell>
                                {user["referralCode"] === "" && <StyledTableCell >-Not Generated-</StyledTableCell>}
                                {user["referralCode"] !== "" && <StyledTableCell >{user["referralCode"]} &nbsp;&nbsp; [ Use this code when you refer someone to this platform. ]</StyledTableCell>}
                                
                            </StyledTableRow>
    <TextField
                        label="Referal's User Code"
                        variant="outlined"
                        name="referredCode"
                        value={profileData["referredCode"]}
                        onChange={handleEditChange}
                        sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                        autoComplete="true"
                    />

           
    */

    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Stack>
                <Box sx={{ paddingBottom: "20px" }}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                            <RenderUpdate />
                        </Grid2>
                        {isStudent() ? <></>
                            :
                            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                                <Stack spacing={2}>
                                    <SelfActivation />
                                    <RenderReferralUpdate />
                                </Stack>
                            </Grid2>
                        }
                    </Grid2>
                </Box>
            </Stack>
        </Box>
    );
};

export default Profile;